// Public - Marketing - Homepage - Homepage Podcast Submit - Add Podcast View
// ----------------------
import React, { 
  //useState, 
  //useEffect 
} from 'react'
import { useSelector, } from 'react-redux'
import { selectPodcastSubmit, } from '../podcastSubmitSlice'

import { Navigate, 
  //useNavigate, 
  useLocation, 
} from "react-router-dom"
import { motion } from "framer-motion"

import PodcastRssValidate from './podcast-rss-validate'
import PodcastRssPreview from './podcast-rss-preview'
import PodcastSubmit from './podcast-submit'

import {
  Segment,
  Card,
  Header,
  Grid,
  Label,
  //Button,
} from 'semantic-ui-react';

// styles
import styles from './add-podcast-view.module.scss';

export default function LandingView() {
  const location = useLocation();
  const { view, status, podcastFollows } = useSelector(selectPodcastSubmit);

  const cardVariants = {
    offscreen: {
      x: 300,
      scale: 0.8, 
      opacity: 0
    },
    onscreen: {
      x: 0,
      scale: 1, 
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8
      }
    },
    exit: {
      x: -300,
      scale: 0.8, 
      opacity: 0
    },
  };

  return (
    <>
      {(view === 'verify-podcast') ?
        <section className={styles.podcast_submit_view}>
          <Segment basic id="podcast-submit-view" className={'hero-content-wrapper view-verify'}>
            <motion.div className="card-container"
              initial="offscreen"
              whileInView="onscreen"
              exit="exit"
              viewport={{ once: true, amount: 0.8 }}
              //layout
            >
              <motion.div layout className="card-wrapper" variants={cardVariants}>
                <Grid centered stackable reversed={'mobile'} columns={'equal'} className={'main-grid'}>
                  <Grid.Row>
                    {/* {status === 'rss-url-valid' ? */}
                    {status === 'podcast-search' ?
                      <Grid.Column className={'view-rss-url-valid podcast-content-column'} width={10}>
                        <Segment className={'podcast-content-container'}>
                          <Segment basic className={'podcast-content-header'}>
                            <Grid stackable centered>
                              <Grid.Row>
                                <Grid.Column width={12}>
                                  <Header>
                                    Select Podcasts to Follow on iHeartRadio
                                    <Header.Subheader>
                                      Podcasts already Followed on iHeartRadio will not be included for import.
                                    </Header.Subheader>
                                  </Header>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                  {!podcastFollows.loading ?
                                    <Label>
                                      Total Selected: {podcastFollows.totalFollows}
                                    </Label>
                                  :
                                    null
                                  }
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Segment>
                          <PodcastRssPreview />
                        </Segment>
                      </Grid.Column>
                    :
                      null
                    }
                    <Grid.Column computer={status === 'podcast-search' ? 6 : 8} tablet={16}>
                      <Card fluid className={'branded'}>
                        <Card.Content textAlign={'center'} className={'card-main-content'}>
                          {status === 'podcast-search' ?
                            <PodcastSubmit />
                          :
                            <PodcastRssValidate />
                          }
                        </Card.Content>
                      </Card>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </motion.div>
            </motion.div>
          </Segment>
        </section>
      :
        <Navigate to={'/'} state={{ from: location }} replace />
      }
    </>
  )
}